export default {"src":"/_next/static/media/icon-charter.85662c1c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};